<template>
	<SoftSwitch v-model="oplVisible" class="m-2" :label="$t('dataType.overpressure')" />
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent } from "vue";
import { defaultEventListOptions, EventListOptions } from "./event-list-options";

export default defineComponent({
	name: "EventListPluginConfig",
	props: {
		modelValue: {
			type: Object as PropType<EventListOptions>,
			default: () => defaultEventListOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);
		const oplVisible = useRefObjectSync(valueModel, "oplVisible");

		return { oplVisible };
	},
});
</script>
